import React, { useState } from 'react';

function BookingPolicy() {
    const [openPolicy, setOpenPolicy] = useState(null);
    
    const policies = [
        {
          title: "Appointment Basics",
          content: [
"Please wear comfortable clothes and bring a government-issued photo ID with you.", 
" Arrive on time, well-hydrated, and moisturized to ensure the best outcome.",
"I provide an estimated number of hours for the tattoo before your appointment.",
"Please avoid scheduling anything right after, as various factors may impact the total time needed.",
          ]
        },
        {
            title: "Age Restriction",
            content: [
              "You must be 18 or older to get tattooed.", 
              "A valid government-issued photo ID is required.",
            ]
      },
      {
        title: "Additional Guests",
        content: [
          "Coming alone is preferred to help keep the space calm and focused.", 
          "However, if you need support (whether for a disability or emotional comfort), you’re welcome to bring one guest.", 
          "Please note they’ll need to stay in the waiting area and remain quiet during the session.",
        ]
      },
    
      {
      title: "Payment Method",
      content: [

        "To secure your appointment, an $80 non-refundable deposit is required via Venmo or card and it will go towards the total cost of your tattoo.",
        "If deposit is paid by card, an additional $3 will be added to cover transaction fees.",
        "The remaining balance can be paid on the day of your session by cash, Venmo, or card.",
        "Please note that a 3% transaction fee will be added to payments made by card. Cash is always preferred.",
      ]
    },
    {
      title: "Pricing",
      content: [
        "My session minimum is $200.",
        "I charge by each piece, not by the hour.",
        "The price of each piece is based on the estimated work hours, the approximate size and the complexity.",
        "Custom designs have an added $60 drawing fee and this includes 1 or 2 alternative variations.",
        "In general, larger designs, heavy black fill, or fine details on stretchy areas can take more time.",
        "These things don’t always mean it’ll cost more, but they help me determine where a piece fits within my pricing system and I'm always open to working with your budget.",
      ]
    },
    {
      title: "Tips",
      content: [
        "Tipping is never required or expected but always greatly appreciated.",
        "Paying your remaining balance in cash is also a great way to support my work.",
      ]
    },
    {
      title: "Available Designs",
      content: [
        "All available designs on the website are repeatable 2-3 times at my discretion.", 
        "Each design is displayed with its recommended size, estimated work hours, and price.",
        "Size adjustment and design edits are available, but please note that changes to the size may increase the price."
      ]
    },
    {
      title: "Custom Designs",
      content: [
        "If you have a custom tattoo request, please share it with me via email before paying the deposit to book your appointment.",
        "This ensures that the idea aligns with my style and that we’re a good fit for the project.",
        "Once I receive your custom design idea, I’ll get back to you within 3 days to let you know if I am the right fit to bring your vision to life.",
        "If so, I’ll also provide an estimated work hours and a fixed price.",
        "You can then send the deposit and book your appointment. I’ll begin working on your design and share the design 2-3 days before your session, along with 2 alternative versions. We can discuss which option works best, and you’re welcome to request edits if needed.",
        "I’m open to a wide range of ideas and enjoy exploring different styles, but please understand there are artistic boundaries to consider.",
        "The more specific details you can provide, the better—things like your concept, reference images (or your own drawings), color preferences, placement, size, and budget will all help in creating the right piece for you.",
      ]
    },
    {
      title: "Placement",
      content: [
        "I don't tattoo palms, elbows, armpits, genitals, knees, the inside of the lips, or the bottoms of the feet.",
        "These areas aren’t suitable for my designs and may not provide the best long-term results.",
      ]
    },
    {
      title: "Touch Up",
      content: [
    "Touch-ups are free of charge.", 
    "If you'd like to refresh your tattoo or make any adjustments, feel free to reach out! Just email me a clear photo of your tattoo along with your preferred dates.", 
    "I want your tattoo to look lovely for as long as possible."
      ]
    },
    {
      title: "Reschedule / Cancellation / Late Policy",
      content: [
        "If you need to reschedule, please give at least 5 days notice prior to your appointment via email. Rescheduling must be done within 2 months of your original appointment.",
        "If you reschedule a second time, a new deposit will be required.",        
        "If you cancel your appointment, please understand that your deposit is non-refundable.", 
        "In the case of a no-show, I will no longer be able to accept you as a client in the future.",
        "If you're more than 30 minutes late without prior notice, the deposit will no longer be applied toward the total cost of the tattoo.",
        "I understand that life happens and can be flexible about the policy, as long as we can be respectful of each other’s time."
      ]
    },
   
    // {
    //   title: "Note: Booking Time",
    //   content: [
    //     "The booking widget will display 2 hours for the meeting time. Just ignore that, as the time will be based on the tattoo work hours.",
    //     "If no time on the booking widget works for you, please contact me at: contact@moolmit.tattoo."
    //   ]
    // },
  ];

  const togglePolicy = (index) => {
    setOpenPolicy(openPolicy === index ? null : index);
  };

  return (
    <div className="w-full max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-6">Please read each policy before booking :)</h2>
      <div className="divide-y divide-black">
        {policies.map((policy, index) => (
          <div key={index} className="py-4">
            <button
              onClick={() => togglePolicy(index)}
              className="w-full flex justify-between items-center text-left focus:outline-none"
            >
              <h3 className="text-xl">{policy.title}</h3>
              <span className="text-2xl transform transition-transform duration-200" 
                    style={{ transform: openPolicy === index ? 'rotate(45deg)' : 'rotate(0)' }}>
                +
              </span>
            </button>
            
            {openPolicy === index && (
              <div className="mt-4 pl-4 space-y-2 text-gray-800">
                {policy.content.map((text, idx) => (
                  <p key={idx} className="text-base">{text}</p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default BookingPolicy;
